import { render, staticRenderFns } from "./BrbMedia.vue?vue&type=template&id=091d7f16&"
import script from "./BrbMedia.vue?vue&type=script&lang=js&"
export * from "./BrbMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('091d7f16')) {
      api.createRecord('091d7f16', component.options)
    } else {
      api.reload('091d7f16', component.options)
    }
    module.hot.accept("./BrbMedia.vue?vue&type=template&id=091d7f16&", function () {
      api.rerender('091d7f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/BrbMedia.vue"
export default component.exports